<template>
  <div
    :data-uid="section.uid"
    :class="`--${sid}--element`"
  >
    <highliter
      v-model="section.name"
      :dublicate="section"
      :dublicate-deep="parentUID"
      class="highlight-element w-auto"
      section-type="element"
      @delete="$emit('delete')"
      @dublicate="$emit('dublicate')"
      @favorite="$emit('favorite', $el)"
      @flow="handleFlow"
      @move-to="to => $emit('move-to', to)"
      @add-subject="$emit('add-subject')"
      @click.stop.native="sectionSettings('flexText')"
    >
      <RichTextContentEditable
        v-model="section.options.content.flexText.text"
        @input="val => section.options.content.flexText.text = val"
      />
    </highliter>
  </div>
</template>

<script>
import SectionMixin from '@builder/components/mixins/SectionMixin'
import RichTextContentEditable from '@/components/builder/utils/RichTextContentEditable.vue'
import Highliter from '@builder/components/builder/utils/Highliter'

export default {
  name: 'ElDrmFlexText',
  components: {
    RichTextContentEditable,
    Highliter
  },
  mixins: [SectionMixin]
}
</script>
